import * as ACTION from 'actions'

export function operators(state=[], action) {
    if(action == null) return  state;
    let operators = Object.assign([], state);
    let index = -1;

    switch (action.type) {
        case ACTION.FETCH_USERS:
            return action.operators;
        case ACTION.ADD_USER:
            return [
                ...state,
                action.user
            ];
        case ACTION.DELETE_USER:
            index = state.findIndex(data => data.id === action.user.id);
            operators.splice(index, 1);
            return operators;
        case ACTION.EDIT_USER:
            index = state.findIndex(data => data.id === action.user.id);
            operators[index] = action.user;
            return operators;
        default:
            return state
    }
}



export function me(state={}, action) {
    switch (action.type) {
        case ACTION.FETCH_ME:
            return action.me;
        default:
            return state;
    }
}